import { render, staticRenderFns } from "./DoubleSwitchWidget.vue?vue&type=template&id=320e80b3"
import script from "./DoubleSwitchWidget.vue?vue&type=script&lang=js"
export * from "./DoubleSwitchWidget.vue?vue&type=script&lang=js"
import style0 from "./DoubleSwitchWidget.vue?vue&type=style&index=0&id=320e80b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports